import Vue from "vue";
// 创建一个新的Vue实例作为事件总线
const EventBus = new Vue();
// 导出事件总线，以便在其他文件中使用
export default EventBus;
